import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { getConnectedEdges, Handle, useNodeId, useStore } from "reactflow";

const selector =
  (nodeId, handle, type, isConnectable = true, maxConnections = Infinity) =>
  (s) => {
    if (!isConnectable) return false;

    const node = s.nodeInternals.get(nodeId);

    const connectedEdges = getConnectedEdges([node], s.edges);
    return (
      maxConnections !== 0 &&
      (connectedEdges.length < maxConnections ||
        connectedEdges.filter((edge) => edge[type] === nodeId && edge[type + "Handle"] === handle).length <
          maxConnections)
    );
  };

function CustomHandle({ maxConnections, ...props }) {
  const nodeId = useNodeId();

  const dataPipeline = useSelector((state) => state.dataPipeline);
  const { editJob } = useMemo(() => dataPipeline, [dataPipeline]);

  const isConnectable = useStore(selector(nodeId, props.id, props.type, props.isConnectable, maxConnections));

  return <Handle isConnectable={editJob === null && isConnectable} {...props} />;
}

export default React.memo(CustomHandle);
